import { cacheConfig, http } from '../helpers/axiosHelper';

export default class ColorSchemeService {
   async createScheme(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/colorscheme', body).then((response) => {
         return response.data;
      });
   }

   async editScheme(id: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/colorscheme/' + id, body).then((response) => {
         return response.data;
      });
   }

   async getColorSchemes() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/colorscheme', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
}
